/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown>, email: NonNullable<unknown> }} Creator_Auth_Error_License_TextInputs */



/**
* | output |
* | --- |
* | "There was an issue verifying your license: {message} Please contact support for more help: {email}" |
*
* @param {Creator_Auth_Error_License_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const creator_auth_error_license_text = /** @type {((inputs: Creator_Auth_Error_License_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Creator_Auth_Error_License_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Un probleme est survenu lors de la verification de votre licence : ${i?.message}
Veuillez contacter le support pour obtenir de l'aide : ${i?.email}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Bei der Überprüfung Ihrer Lizenz ist ein Problem aufgetreten: ${i?.message}
Bitte kontaktieren Sie den Support für weitere Hilfe: ${i?.email}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Si è verificato un problema durante la verifica della tua licenza: ${i?.message}
Contatta l'assistenza per ulteriore assistenza: ${i?.email}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Возникла проблема при проверке вашей лицензии: ${i?.message}
Для получения дополнительной помощи обратитесь в службу поддержки: ${i?.email}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Hubo un problema al verificar su licencia: ${i?.message}
Para obtener más ayuda, póngase en contacto con el servicio de asistencia: ${i?.email}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`验证您的许可证时出现问题：${i?.message}

请联系客服获取更多帮助：${i?.email}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`ライセンスの確認中に問題が発生しました: ${i?.message}
詳細については、サポートにお問い合わせください: ${i?.email}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`आपके लाइसेंस को सत्यापित करने में समस्या आ रही है: ${i?.message}
अधिक सहायता के लिए कृपया सहायता टीम से संपर्क करें: ${i?.email}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Ocorreu um problema ao verificar sua licença: ${i?.message}
Entre em contato com o suporte para obter mais ajuda: ${i?.email}`)
	return /** @type {LocalizedString} */ (`There was an issue verifying your license: ${i?.message}
Please contact support for more help: ${i?.email}`)
});